import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="A beautiful landscape representing the cannabis culture in Florida" 
          style={{ 
            width: '100%', 
            maxHeight: '400px', 
            objectFit: 'cover' 
          }} 
        />
        <p className="eyebrow">Florida Cannabis Information</p>
        <h1>Your Trusted Source for Cannabis Policy and Culture in Florida</h1>
        <p className="lede">
          Delivering essential updates and educational resources on cannabis laws and cultural developments in Florida.
        </p>
        <div className="cta-row">
          <a href="/listings" className="cta-button">
            Explore Our Coverage
          </a>
        </div>
      </header>

      <section className="value-proposition">
        <h2>What We Offer</h2>
        <p>
          Our platform serves as a comprehensive resource for understanding Florida's cannabis policies, legal status, and cultural insights. 
          Stay updated with the latest news and educational content to navigate the evolving landscape of cannabis in the state.
        </p>
        <ul>
          <li>Timely updates on cannabis laws and regulations in Florida</li>
          <li>Educational articles on the implications of cannabis policy</li>
          <li>Insights into the cultural significance of cannabis in the community</li>
          <li>Guides to help you understand the legal status of cannabis in your area</li>
        </ul>
      </section>
    </div>
  );
}

export default App;